import { render, staticRenderFns } from "./excludeAmountCom.vue?vue&type=template&id=653b27ec&scoped=true"
import script from "./excludeAmountCom.vue?vue&type=script&lang=js"
export * from "./excludeAmountCom.vue?vue&type=script&lang=js"
import style0 from "./excludeAmountCom.vue?vue&type=style&index=0&id=653b27ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653b27ec",
  null
  
)

export default component.exports